import React, { useContext, useEffect } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { ResidentialMenu } from "./ResidentialMenu";
import { Context } from "services";
import { useRouter } from "next/router";
interface ResidentialPropertiesProps {
  defaultLocation?: any;
}

export default function ResidentialProperties({
  defaultLocation,
}: ResidentialPropertiesProps) {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);

  useEffect(() => {
    if (!searchForm?.value?.city?.value && defaultLocation) {
      searchForm.setField("asset_type", { value: "residential" });
      searchForm.setField("sub_asset_type", "");
      searchForm.setField("city", {
        value: defaultLocation.city_slug,
        label: defaultLocation.city_name,
      });
    }
  }, [searchForm, defaultLocation]);

  return (
    <>
      {/* Residential Property */}
      <div className=" lg:flex ">
        <div className="w-full pl-4 lg:px-customPadding mt-4 lg:mt-20 py-[42px] lg:py-[50px] 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0 ">
          {/* Heading */}
          <div className="flex items-center pr-10 lg:pr-0">
            <p className="lg:hidden font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h2 leading-9 lg:leading-[57px] text-brand-textBlack">
              RESIDENTIAL PROPERTIES
            </p>
            <p className="hidden lg:flex font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h2 leading-9 lg:leading-[57px] text-brand-textBlack uppercase">
              {`RESIDENTIAL PROPERTIES IN ${searchForm.value.city?.label}`}
            </p>
            <Button
              onClick={() =>
                router.push(
                  `/residential-auction-properties-in-${searchForm.value.city?.value}`
                )
              }
              className="hidden lg:flex ml-auto h-[60px] w-[187px]"
            >
              <p className="font-openSans font-semibold text-[22px] leading-[30px] text-brand-textWhite">
                View all
              </p>
            </Button>
          </div>
          {/* Cards */}
          <div className="mt-6 lg:mt-[70px] ">
            <ResidentialMenu />
          </div>

          <div className="pr-4 w-full mt-[52px]  flex justify-center">
            <Button className="lg:hidden w-[350px] h-10 ">
              <p className="font-openSans font-semibold text-mobile-body-md  leading-4  text-brand-textWhite">
                View all
              </p>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
